// Export the Component Definition for use in Contentful Studio
export {DoubleTheDonationContentfulComponentDefinition} from './DoubleTheDonationContentfulDefinition';
export {default as default} from './DoubleTheDonation';
